import { createAction, props } from '@ngrx/store'
import type { EmployeeBasicInfoDto, AuthResultDto, MenuDto } from './auth.model'

// login action
export const login = createAction(
  '[Authentication] Login',
  props<{ email: string; password: string }>()
)
export const loginSuccess = createAction(
  '[Authentication] Login Success',
  props<{ employee: EmployeeBasicInfoDto; authResult: AuthResultDto; menus: MenuDto[] }>()
)
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: string }>()
)

// logout action
export const logout = createAction('[Authentication] Logout')

export const logoutSuccess = createAction('[Auth] Logout Success')

/** Rehydrates the store from the cookie-backed session on app bootstrap — see authGuard. */
export const restoreSession = createAction(
  '[Authentication] Restore Session',
  props<{ employee: EmployeeBasicInfoDto; authResult: AuthResultDto; menus: MenuDto[] }>()
)
